import { useTranslation } from 'react-i18next'
import { Badge } from '@/shared/components/ui/badge'
import type { OwnRole } from '@/shared/lib/auth/auth-provider'
import { EffectivePermissionsPanel } from './effective-permissions-panel'

interface MyRolesSectionProps {
  roles: OwnRole[]
  isLoading: boolean
}

/** My Access: each of the caller's roles by name, with the matrix of what it grants (UC-084.9). */
export function MyRolesSection({ roles, isLoading }: MyRolesSectionProps) {
  const { t } = useTranslation()

  if (isLoading) return <p className="text-xs text-muted-foreground">{t('userAccess.loadingRoles')}</p>
  if (roles.length === 0) return <p className="text-xs text-muted-foreground">{t('userAccess.noRoles')}</p>

  return (
    <div className="flex flex-col gap-4">
      {roles.map((role) => (
        <div key={role.id} className="rounded-md border p-3">
          <div className="mb-2 flex items-center gap-2">
            <span className="font-medium">{role.name}</span>
            {!role.isPreset && <Badge variant="outline" className="text-[10px]">{t('userRolesDialog.custom')}</Badge>}
          </div>
          <EffectivePermissionsPanel modules={role.modules} title={t('userAccess.rolePermissions')} />
        </div>
      ))}
    </div>
  )
}
